import MigratortronBaseService from './MigratortronBaseService';
import { MigrateRequest } from '~/models/Operations';

class ContentTypeService extends MigratortronBaseService {
  constructor(payload: MigrateRequest, preview: boolean) {
    super(payload, preview);
  }
}

export default ContentTypeService;
